var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1972 4.375H5.80188C5.20796 4.37547 4.62694 4.54832 4.12934 4.87257C3.63175 5.19682 3.23896 5.65853 2.99866 6.20167C2.75836 6.74481 2.68087 7.34602 2.77561 7.93233C2.87035 8.51865 3.13323 9.06487 3.53235 9.50469L13.6714 20.6555V31.1719C13.6715 31.3774 13.7295 31.5788 13.8388 31.7529C13.9481 31.927 14.1043 32.0668 14.2894 32.1563C14.4373 32.2292 14.6002 32.2666 14.7652 32.2656C15.0138 32.2654 15.2549 32.1806 15.4488 32.025L17.4995 30.3844L20.9175 27.65C21.0454 27.5476 21.1487 27.4178 21.2197 27.2701C21.2907 27.1224 21.3276 26.9607 21.3277 26.7969V20.6555L31.4667 9.50469C31.8659 9.06487 32.1287 8.51865 32.2235 7.93233C32.3182 7.34602 32.2407 6.74481 32.0004 6.20167C31.7601 5.65853 31.3673 5.19682 30.8697 4.87257C30.3721 4.54832 29.7911 4.37547 29.1972 4.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter1);
export default __webpack_public_path__ + "static/media/filter 1.118a71134f24d0432b5c2fe0884c06fa.svg";
export { ForwardRef as ReactComponent };